import { useCallback, useEffect, useState } from "react";
import {
  errorMessage,
  fetchBlingConfig,
  fetchBlingStatus,
  fetchNaturezasOperacao,
  saveBlingConfig,
} from "../services/blingService";

// Status da conexão + configuração fiscal da integração com o Bling.
export function useBlingSettings() {
  const [status, setStatus] = useState(null);
  const [config, setConfig] = useState(null);
  const [naturezas, setNaturezas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const reload = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const [nextStatus, nextConfig] = await Promise.all([
        fetchBlingStatus(),
        fetchBlingConfig(),
      ]);
      setStatus(nextStatus);
      setConfig(nextConfig);
      if (nextStatus?.connected) {
        // Natureza de operação é opcional — falha aqui não bloqueia a tela.
        setNaturezas(await fetchNaturezasOperacao().catch(() => []));
      }
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  const save = useCallback(async (changes) => {
    setSaving(true);
    setError(null);
    try {
      const saved = await saveBlingConfig(changes);
      setConfig(saved);
      return saved;
    } catch (err) {
      setError(errorMessage(err));
      return null;
    } finally {
      setSaving(false);
    }
  }, []);

  return { status, config, naturezas, loading, saving, error, save, reload };
}
